import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import Divider from '@mui/material/Divider';
import { TableContainer } from '@mui/material';
import TableFooter from '@mui/material/TableFooter';
import Table from '@mui/material/Table';



export default function AlreadyExistsDialog(props) {
    const classes = useStyles();
    const [foreignObject, setForeignObject] = useState({});
    const [objectToSave, setObjectToSave] = useState({});
    const [existingRegistration, setExistingRegistration] = useState({});

 
    useEffect(() => {
        setObjectToSave(props.objectToSave);
        setForeignObject(props.foreignObjects);
        setExistingRegistration(props.existingRegistration);

    });

    return <Dialog onClose={props.handleClose} aria-labelledby="customized-dialog-title" open={props.open}         maxWidth={'md'}
    >
                <DialogContent dividers>
                    <div className={classes.dialog}>
                        <Typography className={classes.deleteText}>{"Deze registratie bestaat al."}</Typography>
                        <Divider />

                        <div className={classes.spacer15}></div>
                        <p>{"Maak een nieuwe registratie aan of combineer met de bestaande."}</p>

                        <div>
                                {Object.keys(foreignObject).length > 0 && Object.keys(objectToSave).length && Object.keys(existingRegistration).length ?
                                                            <Table size="sm" key={"table"}>
   <table className={classes.table}>
                                <thead className={classes.thead}> 
                                     <tr className={classes.tableRow}>
                                        <th className={classes.tableData} style={{width: '33%'}}>Data</th>
                                        <th style={{width: '33%'}}>Bestaande registratie</th>
                                        <th style={{width: '33%'}}>Nieuwe registratie</th>
                                    </tr>
                                </thead>

                                <tbody> 
                                    <tr style={{border: '1px solid black'}}>
                                        <td className={classes.tableData}>Oorsprong</td>
                                        <td>{existingRegistration.originName}</td>
                                        <td>{(foreignObject.originId).find(x => x.id === objectToSave.OriginId).name }</td>
                                    </tr>
                                    <tr style={{border: '1px solid black'}}>
                                        <td className={classes.tableData}>Bestemming</td>
                                        <td>{existingRegistration.destinationName}</td>
                                        <td>{(foreignObject.destinationId).find(x => x.id === objectToSave.DestinationId).destinationDescription }</td>
                                    </tr>
                                    <tr style={{border: '1px solid black'}}>
                                        <td className={classes.tableData}>Materiaal</td>
                                        <td>{existingRegistration.materialDescription}</td>
                                        <td>{(foreignObject.materialId).find(x => x.id === objectToSave.MaterialId).materialDescription }</td>
                                    </tr>
                                    <tr style={{border: '1px solid black'}}>
                                        <td className={classes.tableData}>Inzamelwijze</td>
                                        <td>{existingRegistration.collectionMethodName}</td>
                                        <td>{(foreignObject.collectionMethodId).find(x => x.id === objectToSave.CollectionMethodId).name }</td>
                                    </tr>
                                    <tr style={{border: '1px solid black'}}>
                                        <td className={classes.tableData}>Periode</td>
                                        <td>{(existingRegistration.periodValue).split('T')[0]}</td>
                                        <td>{objectToSave.PeriodValue}</td>
                                    </tr>
                                    <tr style={{border: '1px solid black'}}>
                                        <td className={classes.tableData}>Aantal</td>
                                        <td>{existingRegistration.quantity}</td>
                                        <td>{objectToSave.Quantity}</td>
                                    </tr>
                                </tbody>
                               

                                

                            </table>
                            </Table>
                                : 
                                <React.Fragment></React.Fragment>
                                
                                }
                         
                        </div>
                        <Button autoFocus variant="outlined" onClick={() => props.handleSave()} color="primary">
                            {"Unieke/nieuwe registratie"}
                        </Button>
                        <Button className={classes.combineButton} variant="contained" onClick={() => props.handleCombine()} color="primary">
                            {"Combineer"}
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
}

const useStyles = makeStyles({
    spacer15: {
        height: '15px'  
      },
      thead: {
        border: '1px solid black',
        marginBottom: '10px',
      },
      table: {
        border: '1px solid black',
        marginBottm: '15px',
      },
      tableRow:{
        border: '1px solid black'

      },
      tableData: {
          border: '1px solid #1F8FA5',
        backgroundColor: '#1F8FA5',
        color: 'white',
      },
      paper: {
          padding: '50px',
          margin: "50px",
          height: '70%'
      },

      dialog: {
          width: "700px",
          paddingLeft: "60px",
          paddingRight: "60px",
          paddingTop: "15px",
          paddingBottom: "15px",
          justifyContent: "center",
          textAlign: "center"
      },

      deleteIcon: {
          fontSize: "100pt",
          color: "gray",
          width: "100px !important",
          height: "100px !important",
      },

      deleteText: {
          fontSize: "20pt"
      },

      deleteTexsmall: {
          fontSize: "14pt"
      },

      combineButton: {
          backgroundColor: "#1F8FA5 !important",
          margin: "10px"
      },
});